import ReleasedDocumentsTable from '@/components/ReleasedDocumentsTable';
import { useUser } from '@/providers/UserProvider';
import {
  useReleasedDocuments,
  useReleasedDocumentsDownload,
} from '@/hooks/releases/useReleasedDocuments';

interface SiteFinalDocumentsProps {
  siteId: string;
}

/**
 * Site-level Final Documents: what Univo has released to THIS site.
 *
 * Unlike the study surface, this is not a roll-up. Documents released
 * study-wide do not appear here — a site sees what was released to it.
 * Read-only for every customer role; documents enter only by being released.
 */
const SiteFinalDocuments = ({ siteId }: SiteFinalDocumentsProps) => {
  const { userData } = useUser();
  const { documents, isLoading, error } = useReleasedDocuments({
    scope: 'site',
    id: siteId,
  });
  const { download, isDownloading, downloadError, zipExportId } =
    useReleasedDocumentsDownload('site', siteId);

  return (
    <ReleasedDocumentsTable
      documents={documents}
      isLoading={isLoading}
      error={error}
      onDownload={download}
      isDownloading={isDownloading}
      downloadError={downloadError}
      zipExportId={zipExportId}
      userId={userData?.id}
    />
  );
};

export default SiteFinalDocuments;
